import { FieldMapping, Mapping } from './csv';
import { matchSorter } from 'match-sorter';

// Mettre les guess par ordre de priorité et par spécificité
// le 1er mot qui match au moins un élément ressort
const fieldsMapped: { [key: FieldMapping]: string[] } = {
  givenName: ['prenom'],
  familyName: ['nom élève', 'nom'],
  birthday: ['date', 'naissance'],
  gender: ['genre', 'sexe'],
  classe: ['libellé classe'],
  niveau: ['niveau'],
  idbe: ['identifiant classe'],
  ine: ['ine'],
};

export function fuzzySearchHeader(items: string[], filter: string): string[] {
  return filter
    ? matchSorter(items, filter, {
        threshold: matchSorter.rankings.CONTAINS, // default is MATCHES, which is too permissive (" item has letters in the same order as the letters of the given value")
      })
    : items;
}

export function guessMapping(headers: string[]): Mapping[] {
  // Pour chaque header, trouver le meilleur field correspondant
  const guesses: { [key: string]: FieldMapping } = {};

  headers.forEach(header => {
    // Tester chaque field dans l'ordre de priorité
    const fieldsInOrder: FieldMapping[] = [
      'givenName',
      'familyName',
      'birthday',
      'gender',
      'classe',
      'niveau',
      'idbe',
      'ine', // INE en dernier pour éviter les faux positifs
    ];

    for (const field of fieldsInOrder) {
      const patterns = fieldsMapped[field];
      for (const pattern of patterns) {
        const matches = fuzzySearchHeader([header], pattern);
        if (matches.length > 0) {
          guesses[header] = field;
          break; // Arrêter dès qu'on trouve un match
        }
      }
      if (guesses[header]) break; // Sortir de la boucle des fields si on a trouvé
    }
  });

  return headers.map((h, i) => ({
    index: i,
    header: h,
    mapping: guesses[h] || 'skip',
    checked: true,
  }));
}
